import React, { useState } from 'react';


export default function Auth() {
   return localStorage.getItem('admin_api_token');
}